<template>
	<svg
		id="Group_45730"
		data-name="Group 45730"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="231"
		height="151"
		viewBox="0 0 231 151"
	>
		<defs>
			<clipPath id="clip-path-TableMapper">
				<rect
					id="Rectangle_15382"
					data-name="Rectangle 15382"
					width="31.698"
					height="31.698"
					transform="translate(99.541 66.603)"
					fill="none"
				/>
			</clipPath>
		</defs>
		<g id="Group_45727" data-name="Group 45727">
			<g id="Group_45737" data-name="Group 45737">
				<path
					id="Path_32871"
					data-name="Path 32871"
					d="M220.044,150.562H11.055A10.581,10.581,0,0,1,.473,139.981V13.4H230.527v126.68a10.483,10.483,0,0,1-10.483,10.483"
					fill="#f7f8fb"
				/>
				<path
					id="Path_32872"
					data-name="Path 32872"
					d="M220.24.5H10.761C5.085.5.473,5.476.473,11.576v1.8H230.527v-1.8C230.527,5.476,225.916.5,220.24.5"
					fill="#f7f7f7"
				/>
				<path
					id="Path_32873"
					data-name="Path 32873"
					d="M220.24.5H10.761C5.085.5.473,5.476.473,11.576v1.8H230.527v-1.8C230.527,5.476,225.916.5,220.24.5"
					fill="#f7f7f7"
				/>
				<path id="Path_32874" data-name="Path 32874" d="M12,7.54A2.145,2.145,0,1,1,9.86,5.39,2.151,2.151,0,0,1,12,7.54" fill="#f7f8fb" />
				<path id="Path_32875" data-name="Path 32875" d="M18.33,7.54a2.15,2.15,0,1,1-2.15-2.15,2.153,2.153,0,0,1,2.15,2.15" fill="#f7f8fb" />
				<path id="Path_32876" data-name="Path 32876" d="M24.66,7.54a2.15,2.15,0,1,1-2.15-2.15,2.16,2.16,0,0,1,2.15,2.15" fill="#f7f8fb" />
				<path
					id="Path_32877"
					data-name="Path 32877"
					d="M185.14,7.56a3.312,3.312,0,0,1-3.3,3.3H48.39a3.3,3.3,0,0,1-3.3-3.3,3.312,3.312,0,0,1,3.3-3.3H181.84a3.3,3.3,0,0,1,3.3,3.3"
					fill="#f7f8fb"
				/>
				<path
					id="Path_32878"
					data-name="Path 32878"
					d="M185.14,7.56a3.312,3.312,0,0,1-3.3,3.3H48.39a3.3,3.3,0,0,1-3.3-3.3,3.312,3.312,0,0,1,3.3-3.3H181.84a3.3,3.3,0,0,1,3.3,3.3"
					fill="#d6dde9"
				/>
				<path id="Path_32879" data-name="Path 32879" d="M12,7.54A2.145,2.145,0,1,1,9.86,5.39,2.151,2.151,0,0,1,12,7.54" fill="#d6dde9" />
				<path id="Path_32880" data-name="Path 32880" d="M18.33,7.54a2.15,2.15,0,1,1-2.15-2.15,2.153,2.153,0,0,1,2.15,2.15" fill="#d6dde9" />
				<path id="Path_32881" data-name="Path 32881" d="M24.66,7.54a2.15,2.15,0,1,1-2.15-2.15,2.16,2.16,0,0,1,2.15,2.15" fill="#d6dde9" />
				<path
					id="Path_32882"
					data-name="Path 32882"
					d="M219.76,0H11.24A11.256,11.256,0,0,0,0,11.24V139.76A11.25,11.25,0,0,0,11.24,151H219.76A11.25,11.25,0,0,0,231,139.76V11.24A11.256,11.256,0,0,0,219.76,0M11.24,1H219.76A10.253,10.253,0,0,1,230,11.24V12.9H1V11.24A10.253,10.253,0,0,1,11.24,1M219.76,150H11.24A10.247,10.247,0,0,1,1,139.76V13.9H230V139.76A10.247,10.247,0,0,1,219.76,150"
					fill="#e5e9ef"
				/>
				<path
					id="Path_32883"
					data-name="Path 32883"
					d="M154.641,24.411h-78.5a9.275,9.275,0,0,0-9.275,9.275v97.532a9.274,9.274,0,0,0,9.275,9.275h78.5a9.274,9.274,0,0,0,9.275-9.275V33.686a9.275,9.275,0,0,0-9.275-9.275"
					fill="#fff"
				/>
				<path
					id="Path_32884"
					data-name="Path 32884"
					d="M154.641,140.993h-78.5a9.785,9.785,0,0,1-9.775-9.775V33.686a9.785,9.785,0,0,1,9.775-9.775h78.5a9.785,9.785,0,0,1,9.775,9.775v97.532a9.785,9.785,0,0,1-9.775,9.775M76.139,24.911a8.785,8.785,0,0,0-8.775,8.775v97.532a8.784,8.784,0,0,0,8.775,8.775h78.5a8.784,8.784,0,0,0,8.775-8.775V33.686a8.785,8.785,0,0,0-8.775-8.775Z"
					fill="#e4e8f2"
				/>
			</g>
		</g>
		<g id="Group_45729" data-name="Group 45729">
			<g id="Group_45728" data-name="Group 45728" clip-path="url(#clip-path-TableMapper)">
				<path
					id="Path_32885"
					data-name="Path 32885"
					d="M126.959,84.823h-4.745a2.155,2.155,0,0,0-2.156,2.155v4.748a2.155,2.155,0,0,0,2.156,2.155h4.745a2.165,2.165,0,0,0,2.156-2.155V86.985a2.163,2.163,0,0,0-2.156-2.156m.254,6.908a.262.262,0,0,1-.254.254h-4.745a.254.254,0,0,1-.254-.254V86.985a.254.254,0,0,1,.254-.254h4.745a.26.26,0,0,1,.254.254Z"
					fill="#5251f8"
				/>
				<path
					id="Path_32886"
					data-name="Path 32886"
					d="M119.4,88.688a.9.9,0,0,0-.148-.127l-3.09-2.148a.937.937,0,0,0-.086-.038,1.041,1.041,0,0,0-.178-.077.788.788,0,0,0-.186-.038.436.436,0,0,0-.094-.019c-.028,0-.053.014-.081.015a.924.924,0,0,0-.188.039.825.825,0,0,0-.165.063.9.9,0,0,0-.146.1.888.888,0,0,0-.14.127c-.018.021-.043.034-.06.057-.037.087-.076.176-.114.263a.923.923,0,0,0-.038.188c0,.03-.019.06-.019.092V88.4h-3.938V86.985a2.162,2.162,0,0,0-2.156-2.155h-4.753a2.155,2.155,0,0,0-2.156,2.155v4.746a2.155,2.155,0,0,0,2.156,2.155h4.746a2.167,2.167,0,0,0,2.155-2.155V90.313h3.945v1.211c.006.029.011.061.019.092a.946.946,0,0,0,.038.189,1.25,1.25,0,0,0,.074.173c.017.029.021.06.038.089s.037.027.052.044a.886.886,0,0,0,.234.2.729.729,0,0,0,.092.065.991.991,0,0,0,.4.1.974.974,0,0,0,.332-.068.7.7,0,0,0,.1-.046.6.6,0,0,0,.113-.057l3.091-2.146a.894.894,0,0,0,.147-.127.952.952,0,0,0,.192-1.074.88.88,0,0,0-.191-.269m-10.574,3.043a.254.254,0,0,1-.254.254h-4.749a.254.254,0,0,1-.254-.254V86.985a.254.254,0,0,1,.254-.253h4.746a.253.253,0,0,1,.253.253Z"
					fill="#5251f8"
				/>
				<path
					id="Path_32887"
					data-name="Path 32887"
					d="M126.959,71.019h-4.745a2.155,2.155,0,0,0-2.156,2.155V77.92a2.156,2.156,0,0,0,2.156,2.156h4.745a2.167,2.167,0,0,0,2.156-2.156V73.182a2.164,2.164,0,0,0-2.156-2.156m.254,6.908a.262.262,0,0,1-.254.254h-4.745a.254.254,0,0,1-.254-.254V73.182a.254.254,0,0,1,.254-.254h4.745a.261.261,0,0,1,.254.254Z"
					fill="#5251f8"
				/>
				<path
					id="Path_32888"
					data-name="Path 32888"
					d="M119.4,74.88a.953.953,0,0,0-.149-.127l-3.09-2.143a.542.542,0,0,0-.089-.038.859.859,0,0,0-.176-.076.926.926,0,0,0-.18-.036c-.033,0-.062-.019-.1-.019a.511.511,0,0,0-.085.017.906.906,0,0,0-.178.036.992.992,0,0,0-.174.067,1.044,1.044,0,0,0-.284.232c-.018.02-.045.034-.06.057s-.027.059-.038.089a.9.9,0,0,0-.075.171,1.125,1.125,0,0,0-.039.19.713.713,0,0,0-.018.092V74.6h-3.939V73.181a2.164,2.164,0,0,0-2.156-2.155H103.82a2.162,2.162,0,0,0-2.155,2.155v4.746a2.155,2.155,0,0,0,2.155,2.155h4.746a2.165,2.165,0,0,0,2.156-2.155V76.5h3.945v1.211c0,.032.017.06.018.093a1.183,1.183,0,0,0,.039.186.944.944,0,0,0,.076.176c.017.028.019.06.038.088s.037.025.05.044a.937.937,0,0,0,.233.2q.046.035.093.063a.932.932,0,0,0,.4.1.981.981,0,0,0,.33-.067c.034-.014.067-.031.1-.049a1.06,1.06,0,0,0,.112-.055l3.09-2.148a.889.889,0,0,0,.147-.127,1,1,0,0,0,.19-.271.948.948,0,0,0,0-.8.971.971,0,0,0-.188-.27m-10.574,3.043a.262.262,0,0,1-.254.254H103.82a.254.254,0,0,1-.253-.254V73.181a.254.254,0,0,1,.253-.254h4.746a.262.262,0,0,1,.254.254Z"
					fill="#5251f8"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'TableMapperSvg',
};
</script>

<style scoped lang="scss"></style>
